export { Anchor } from "@mantine/core";
export type { AnchorProps } from "@mantine/core";
export { getAnchorOverrides } from "./Anchor.styled";
